export const READY = "READY";
export const NOT_INITIATED = "NOT_INITIATED";
export const LOADING = "LOADING";
export const ERROR = "ERROR";
export const INIT_ERROR = "INIT_ERROR";
export const STALE = "STALE";
// Settled, like READY: the account resolved to no project to open. Distinct
// from NOT_INITIATED, which means the answer isn't in yet.
export const NO_PROJECTS = "NO_PROJECTS";

export const EXISTS = "exists";
export const DOES_NOT_EXIST = "does_not_exist";

export const PROJECT_IDS = "projectIds";

export const EXPORTER_TYPES = {
  DATADOG: "DATADOG",
  CLOUDWATCH: "CLOUDWATCH",
  PROMETHEUS: "PROMETHEUS",
  AZUREMONITOR: "AZUREMONITOR",
};

export const STORE_STATUS = [
  READY,
  NOT_INITIATED,
  LOADING,
  ERROR,
  INIT_ERROR,
  STALE,
  NO_PROJECTS,
] as const;

export const PAYMENT_METHOD_STATUS = [
  EXISTS,
  DOES_NOT_EXIST,
  ...STORE_STATUS,
] as const;

export type StoreStatus = (typeof STORE_STATUS)[number];
export type PaymentStatus = (typeof PAYMENT_METHOD_STATUS)[number];

export enum VISIBILITY_STATE {
  VISIBLE = "visible",
  HIDDEN = "hidden",
}

export const HOURS_PER_MONTH = 730;

export const TRIAL_DAYS = {
  DEFAULT: 30,
  WELCOME_BACK: 60, // Part of an initiative to bring back users.
};

export const MULTI_NODE = "multi-node";
export const SINGLE_NODE = "single-node";

export const FREE_SERVICE_STORAGE_CAP_MIB = 750;
export const FREE_SERVICE_STORAGE_LIMIT = "750 MiB";
